import React, {useEffect, useState} from 'react';
import {Popover, Select} from "antd";
import axios from "axios";
import {API_PATH} from "../../../components/const";
import {toast} from "react-toastify";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {useHistory} from "react-router-dom";

const CameraListConfig = () => {
    let history = useHistory()
    const [offices, setOffices] = useState([])
    const [data, setData] = useState( [])
    const [dataInActive, setDataInActive] = useState( [])
    const [dataObj, setDataObj] = useState([])
    const [parents, setParents] = useState([])

    const getBuilding = (val) => {
        axios.get(API_PATH +"company/" + localStorage.getItem("id") + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCameras = (e) => {
        axios.get(API_PATH +"company/" + localStorage.getItem("id") + "/camera/smartcamera/all/active" +( e !== null ? "?building_id=" + e : "" ), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData( res.data?.items)
                console.log(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCamerasInActive = (e) => {
        axios.get(API_PATH +"company/" + localStorage.getItem("id") + "/camera/smartcamera/all/inactive" +( e !== null ? "?building_id=" + e : "" ), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDataInActive(res.data?.items)
                console.log(res.data?.items)

            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    useEffect(() =>{
        getBuilding("")
        getParentBuilding()
        getCameras(null)
        getCamerasInActive(null)
    }, [])
    return (
        <div className="CameraList">
                <div className="employees-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="left-head">
                            <h6 className="font-family-medium">Список камер</h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">

                            <label className="font-family-medium text-white mb-2">Раздел</label>
                            <div className="inputs-box  "  >
                                <Select
                                    showSearch
                                    placeholder="Выберите раздел"
                                    optionFilterProp="children"
                                    className="w-100"
                                    onSearch={getParentBuilding}
                                    onChange={(e) => getBuilding(e)}
                                    // onChange={(e) => setCountry(e)}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={parents?.map((item) => {
                                        return {
                                            value: item.id,
                                            label:
                                            item?.branch_title
                                        };
                                    })}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="inputs-box">
                            <label className="font-family-medium text-white mb-2">Филиал</label>
                                <div className="d-flex w-100">
                                    <Select
                                        showSearch
                                        placeholder="Выберите филиал"
                                        optionFilterProp="children"
                                        className="w-100"
                                        // onSearch={getBuilding}
                                        // value={sendData?.building_id}
                                        onChange={(e) => {
                                            getCamerasInActive(e)
                                            getCameras(e)
                                        }}
                                        filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                        filterSort={(optionA, optionB) =>
                                            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                        }
                                        options={offices?.map((item) => {
                                            return {
                                                value: item.building_id,
                                                label:
                                                item?.branch_title
                                            };
                                        })}
                                    />
                                </div>
                        </div>
                        </div>
                    </div>

                </div>

            <div className="emp-table mt-4">
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow key={1}>
                                <TableCell className="pl20 table-head" >№</TableCell>
                                <TableCell className="  table-head" >ID устройства</TableCell>
                                <TableCell className="  table-head" >Имя</TableCell>
                                <TableCell className="table-head"  align="left">Здание</TableCell>
                                <TableCell className="table-head"  align="left">IP устройства</TableCell>
                                <TableCell className="table-head"  align="left">Тип</TableCell>
                                <TableCell className="table-head"  align="left">Статус</TableCell>
                                {/*<TableCell className="table-head"  align="left">25.12.2023</TableCell>*/}
                                <TableCell  className="pr20 table-head"  align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((item, index) => (
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell   className="pl20"  scope="row">
                                        <div className="tabel-item">
                                            {/*{*/}
                                            {/*    ( dataObj?.page === 1 ? 0 : (dataObj?.page - 1)  * 20 ) + index + 1*/}
                                            {/*}*/}
                                            {item?.id}
                                        </div>
                                    </TableCell>
                                    <TableCell   scope="row">
                                        <div className="tabel-item">
                                           <div className="tabel-item">
                                               {item?.device_id}
                                           </div>
                                        </div>

                                    </TableCell>
                                    <TableCell   scope="row">
                                        <div className="tabel-item">
                                           <div className="tabel-item">
                                               {item?.name}
                                           </div>
                                        </div>

                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.building?.name}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.device_ip}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.camera_type}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            Активный
                                        </div>
                                    </TableCell>
                                    {/*<TableCell align="left">*/}
                                    {/*    <div className="tabel-item">*/}
                                    {/*        8 часов 12 минуты*/}
                                    {/*    </div>*/}
                                    {/*</TableCell>*/}
                                    <TableCell className="  con-btns-all" align="right">
                                        <div className="tabel-item tabel-item-controls">
                                            <button className="bg-transparent border-0" onClick={() => history.push("/main-cameras/user-management/" + item?.device_id)}>
                                                <img src="/icon/settings2.svg" alt="."/>
                                            </button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {dataInActive?.map((item, index) => (
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell   className="pl20"  scope="row">
                                        <div className="tabel-item">
                                            {/*{*/}
                                            {/*    ( dataObj?.page === 1 ? 0 : (dataObj?.page - 1)  * 20 ) + index + 1*/}
                                            {/*}*/}
                                            {item.id}
                                        </div>
                                    </TableCell>
                                    <TableCell   scope="row">
                                        <div className="tabel-item">
                                           <div className="tabel-item">
                                               {item?.device_id}
                                           </div>
                                        </div>

                                    </TableCell>
                                    <TableCell   scope="row">
                                        <div className="tabel-item">
                                           <div className="tabel-item">
                                               {item?.device_name}
                                           </div>
                                        </div>

                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.building?.name}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.device_ip}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            {item?.camera_type}
                                        </div>
                                    </TableCell>
                                    <TableCell align="left">
                                        <div className="tabel-item">
                                            Неактивный
                                        </div>
                                    </TableCell>
                                    {/*<TableCell align="left">*/}
                                    {/*    <div className="tabel-item">*/}
                                    {/*        8 часов 12 минуты*/}
                                    {/*    </div>*/}
                                    {/*</TableCell>*/}
                                    <TableCell className="  con-btns-all" align="right">
                                        {/*<div className="tabel-item tabel-item-controls">*/}
                                        {/*    <button className="bg-transparent border-0" onClick={() => history.push("/main-cameras/user-management/" + item?.device_id)}>*/}
                                        {/*        <img src="/icon/settings2.svg" alt="."/>*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

        </div>
    );
};

export default CameraListConfig;